module.exports = __webpack_public_path__ + "static/media/web-qr.a33e7996.svg";